import Vue from 'vue';
import Spinner from '@/core/components/Spinner.vue';
import { DEFAULT_LANGUAGE, LANGUAGES } from '@/utils/constants';

export default Vue.extend({
  data() {
    return {
      loading: false,
    };
  },

  components: {
    Spinner,
  },

  computed: {
    getUserLanguage(): string {
      const browser_language = navigator.language;
      return (
        LANGUAGES.find((lang) => lang.codes.some((langCode) => browser_language.match(langCode)))?.value ??
        DEFAULT_LANGUAGE
      );
    },
  },
});
